// PanelSubtask Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SubtaskItem from '../../subtask/subtask_item/subtask_item.jsx'
import SubtaskForm from '../../subtask/subtask_form/subtask_form.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

class PanelSubtask extends Component {
  static get propTypes () {
    return {
      subtasks: PropTypes.array,
      onToggleExpand: PropTypes.func,
      onAdd: PropTypes.func,
      onChange: PropTypes.func,
      onSave: PropTypes.func,
      onComplete: PropTypes.func,
      onReopen: PropTypes.func,
      onDelete: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      subtasks: [],
      onToggleExpand: null,
      onAdd: null,
      onChange: null,
      onSave: null,
      onComplete: null,
      onReopen: null,
      onDelete: null
    }
  }

  render () {
    const {
      subtasks,
      onToggleExpand,
      onAdd,
      onChange,
      onSave,
      onComplete,
      onReopen,
      onDelete
    } = this.props

    return (
      <div className='panel panel-subtask'>
        <div className='addaction'>
          <IconButton
            icon='+'
            type='secondary'
            label='Add subtask'
            canHover
            onClick={onAdd}
          />
        </div>
        {subtasks.map((subtask, idx) => (
          <div
            className={`panel-subtaskitem${subtask._isExpand ? ' expand' : ''}`}
            key={idx}
          >
            <IconButton
              icon={subtask._isExpand ? 'arrow-up' : 'arrow-down'}
              className='action'
              canHover
              onClick={(ev) =>
                onToggleExpand ? onToggleExpand(subtask, ev) : null}
            />
            {subtask._isExpand ? (
              <SubtaskForm
                key={idx}
                subtask={subtask}
                autoFocusTitle
                onChange={onChange}
                onSave={onSave}
                onComplete={onComplete}
                onReopen={onReopen}
                onDelete={onDelete}
              />
            ) : (
              <SubtaskItem
                subtask={subtask}
                key={idx}
                onToggleExpand={onToggleExpand}
              />
            )}
          </div>
        ))}
      </div>
    )
  }
}

export default PanelSubtask
